// extracted by mini-css-extract-plugin
export default {"prevNextWrapper":"ZzKXWu7","indexOfSum":"HkgSKXE","btn":"GcOt8jE","disabled":"UocJfTI"};